import { render, staticRenderFns } from "./PromoElement.vue?vue&type=template&id=7fefd5e0&"
import script from "./PromoElement.vue?vue&type=script&lang=js&"
export * from "./PromoElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports